// @flow
import { css } from 'styled-components';

export const rajdhaniCss = css`
  font-family: 'Rajdhani', 'Averta', 'Lato', sans-serif;
`;
